import { React, useEffect, useState } from "react";
import { View, Platform, Dimensions, useWindowDimensions } from "react-native";
import { Card } from "react-native-paper";
import CustomButton from "../../CustomButton/CustomButton";
import { StyleSheet, SafeAreaView } from "react-native";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useAccountContext } from "../../../hooks/useAccountContext";
import CustomLabel from "../../CustomLabel/CustomLabel";
import { useTheme } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { useAssessment } from "../../../hooks/useAssessment";
import { showMessage } from "react-native-flash-message";
import { generateUniqueID } from "../..//SurveyBuilderComponent/CreateSurvey/CreateSurveyFunctions";
import CustomDropDownWithIcons from '../../CustomDropDownWithIcons';

const CustomParticipants = ({
    setShowParticipationsScreen,
    setShowResponseScreen,
    setShowEditScreen,
    setShowEditGroup,
    setShowCreateScreen,
    setShowCreateGroup,
    setShowMyAssessments,
    setShowCustomParticipants,
    setShowEditParticipant,
    employees,
    partEdit,
    isEdit = 0,
    isCreate,
    toView = 0,
    wfl,
    workflows,
    assmid,
    setShowAssessmentsAdmin,
    setRefresh,
}) => {
    const [screenDimensions, setScreenDimensions] = useState(Dimensions.get('window'));
    useEffect(() => {
        Dimensions.addEventListener('change', ({ window }) => {
            setScreenDimensions(window);
        });
    }, []);

    //#region Const Defninitons
    const { t } = useTranslation();
    const { user, clientApi, username } = useAuthContext();
    const { account } = useAccountContext();
    const { postParticipant } = useAssessment();
    const { colors } = useTheme();
    const { width, height } = useWindowDimensions();
    const isHalfScreen = Platform.OS === "web" && width <= 900;
    const styles = makeStyles(colors, screenDimensions.width, screenDimensions.height, isHalfScreen);
    const isPlatformWeb = Platform.OS === "web" && width > 1300 ? true : false;
    const [selectedAppraiser, setSelectedAppraiser] = useState([])
    const [selectedAppraisee, setSelectedAppraisee] = useState("");
    const [step, setStep] = useState(0);
    const [value, setValue] = useState(0);
    const employeesAvailable = employees.map(employee => {
        return {
            label: `${employee.name} - ${employee.employeeID}`,
            value: employee.employeeID
        };
    });

    // * Participations List
    const [partList, setParticipationsList] = useState(
        {
            assmEmplUI: "",
            assmui: "",
            appraiseeid: "",
            appraiser2: "",
            appraiser3: "",
            appraiser4: "",
            employeeid: "",
            noOfSteps: 0,
            userid: "",
        }
    );
    //#endregion

    //#region UseEffect
    useEffect(() => {
        // * No need to do anything here
    }, [width, height]);

    useEffect(() => {
        const wflObj = workflows.find((obj) => obj.assmType === wfl);
        const steps = wflObj ? wflObj.numberOfSteps : 0;
        const participant = {
            assmEmplUI: isEdit ? partEdit[0].assmEmplUI : generateUniqueID(),
            assmui: assmid,
            appraiseeid: selectedAppraisee === undefined ? "" : selectedAppraisee,
            appraiser2: selectedAppraiser[2] === undefined ? "" : selectedAppraiser[2],
            appraiser3: selectedAppraiser[3] === undefined ? "" : selectedAppraiser[3],
            appraiser4: selectedAppraiser[4] === undefined ? "" : selectedAppraiser[4],
            employeeid: selectedAppraiser[1] === undefined ? "" : selectedAppraiser[1],
            noOfSteps: steps,
            userid: account.employeeId,
        }
        setParticipationsList(participant)
    }, [selectedAppraisee, selectedAppraiser]);

    useEffect(() => {
        const wflObj = workflows.find((obj) => obj.assmType === wfl);
        const steps = wflObj ? wflObj.numberOfSteps : 0;
        if (isEdit) {
            let tempAppraiser = [];
            tempAppraiser[0] = "";
            setSelectedAppraisee(partEdit[0].appraiseeID)
            for (let i = 1; i < steps + 1; i++) {
                tempAppraiser[i] = partEdit[i - 1].appraiserID;
            }
            setSelectedAppraiser(tempAppraiser);
        }
    }, [isEdit]);
    //#endregion

    const handleAppraiseeSelection = (e) => {
        setSelectedAppraisee(e)
    }

    useEffect(() => {
        if (step === 0 && value === 0) { return; }
        const updatedSelectedAppraiser = [...selectedAppraiser];
        updatedSelectedAppraiser[step] = value;
        setSelectedAppraiser(updatedSelectedAppraiser);
    }, [step, value])

    const handleAppraiserSelection = (i, e) => {
        setStep(i);
        setValue(e);
    };

    //#region Save and Cancel
    // * Save Assessment
    const handleSavePartcipant = async () => {
        console.log("Saving...");
        const wflObj = workflows.find((obj) => obj.assmType === wfl);
        const steps = wflObj ? wflObj.numberOfSteps : 0;

        if (partList.appraiseeid == "") {
            showMessage({
                message: "Please enter Appraisee",
                type: "error",
                duration: 3000,
            });
            return;
        }

        for (let i = 1; i <= steps - 1; i++) {
            if (selectedAppraiser[i] === undefined || selectedAppraiser[i] === "") {
                showMessage({
                    message: "Please enter Appraiser",
                    type: "error",
                    duration: 3000,
                });
                return;
            }
        }

        await postParticipant(
            clientApi,
            user.token,
            partList,
            username,
            account.employeeId,
            toView
        )
            .then((response) => {
                showMessage({
                    message: t("common:saveSuccess"),
                    type: "success",
                    duration: 3000,
                });
                setRefresh(1);
                setShowMyAssessments(0);
                setShowAssessmentsAdmin(0);
                setShowCreateScreen(0);
                setShowEditScreen(0);
                setShowEditParticipant(0)
                setShowResponseScreen(0);
                setShowCreateGroup(0);
                setShowCustomParticipants(0);
                setShowParticipationsScreen(1);
            })
            .catch((error) => {
                showMessage({
                    message: "Group failed to save: " + error,
                    type: "error",
                    duration: 3000,
                });
                setShowCustomParticipants(0);
                setShowEditParticipan(0);
                setShowMyAssessments(0);
                setShowAssessmentsAdmin(0);
                setShowCreateScreen(0);
                setShowEditScreen(0);
                setShowResponseScreen(0);
                setShowCreateGroup(0);
                setShowParticipationsScreen(1);
                return false;
            });
    };

    // Cancel addition Of Participant
    const handleCancelParticipant = () => {
        console.log("Cancel..");
        if (toView) setShowMyAssessments(1);
        else setShowParticipationsScreen(1);
        setShowAssessmentsAdmin(0);
        setShowResponseScreen(0);
        setShowEditParticipant(0);
        setShowCreateScreen(0);
        setShowCreateGroup(0);
        setShowEditScreen(0);
        setShowEditGroup(0);
        setShowCustomParticipants(0);
    };
    //#endregion

    //#region Render
    const renderViews = () => {
        let renderedViews = [];
        const wflObj = workflows.find((obj) => obj.assmType === wfl);
        const steps = wflObj ? wflObj.numberOfSteps : 0;
        for (let i = 1; i <= steps; i++) {
            renderedViews.push(
                <View key={i} style={[isPlatformWeb && styles.webColumnsContainer]}>
                    <CustomButton
                        text={" " + i + " "}
                        onPress={() => { }}
                        show="PART"
                        type="PART"
                        textTop="0"
                        sz={20}
                    />
                    <View style={[styles.row, { zIndex: Math.floor(20000 / i) }]}>
                        <View style={[styles.inputContainer]}>
                            <CustomDropDownWithIcons
                                defValue={selectedAppraiser[i]}
                                options={employeesAvailable}
                                value={selectedAppraiser[i]}
                                setValue={(e) => { handleAppraiserSelection(i, e) }}
                                type="PARTICIPANT"
                            />
                        </View>
                    </View>
                </View>
            );
        }
        return renderedViews;
    }
    //#endregion

    if (employeesAvailable.length == 0)
        return (
            <Card style={styles.cardstyle}>
                <Card.Content>
                    <CustomLabel
                        value={t("common:noEmplAuth")}
                        type="ASSM"
                    />
                </Card.Content>
            </Card>
        )

    return (
        <SafeAreaView style={styles.main}>
            <Card style={styles.cardstyle}>
                <SafeAreaView style={[styles.main, { zIndex: 30000 }]}>
                    <View style={[isPlatformWeb && styles.webColumnsContainer, { zIndex: 30000 }]}>
                        <CustomLabel
                            value={t("common:appraisee")}
                            type="PART"
                            show="PART"
                        />
                        <View style={[styles.row]}>
                            <View style={[styles.inputContainer]}>
                                <CustomDropDownWithIcons
                                    defValue={selectedAppraisee}
                                    options={employeesAvailable}
                                    value={selectedAppraisee}
                                    setValue={(e) => { handleAppraiseeSelection(e) }}
                                    type="PARTICIPANT"
                                />
                            </View>
                        </View>
                    </View>
                    <View style={isPlatformWeb && styles.webColumnsContainer}>
                        <CustomLabel
                            value={t("common:stage")}
                            type="PART"
                        />
                        <View style={styles.label_right}>
                            <CustomLabel
                                value={t("common:appraiser")}
                                type="PART"
                            />
                        </View>
                    </View>
                    <View style={styles.line} />
                    <View>
                        {renderViews().map((view, index) => (
                            <SafeAreaView key={index} style={{ zIndex: Math.floor(20000 / (index + 1)) }}>{view}</SafeAreaView>
                        ))}
                    </View>
                </SafeAreaView>
                <Card.Actions>
                    <SafeAreaView style={styles.actions}>
                        <SafeAreaView style={styles.modalButtonsRow}>
                            <CustomButton
                                text={t("common:cancel")}
                                onPress={() => handleCancelParticipant()}
                                iconName="close-circle-outline"
                                show="SURVEYREJECT"
                                type="SURVEYREJECT"
                                textTop="0"
                                sz={25}
                            />
                            <CustomButton
                                text={t("common:save")}
                                onPress={() => handleSavePartcipant()}
                                iconName="save-outline"
                                show="SURVEY"
                                type="SURVEY"
                                textTop="0"
                                isGradient={true}
                                sz={25}
                            />
                        </SafeAreaView>
                    </SafeAreaView>
                </Card.Actions>
            </Card>
        </SafeAreaView>
    );
};

const makeStyles = (colors, width, height, isHalfScreen) => StyleSheet.create({
    main: {
        flex: 1,
        alignContent: "center",
    },
    row: {
        flex: 1,
        flexDirection: "row"
    },
    label_right: {
        flex: 4,
        justifyContent: "center",
        alignSelf: "center",
        flexDirection: "row",
    },
    webColumnsContainer: {
        flex: 1,
        flexDirection: "row",
        marginTop: 15,
    },
    line: {
        borderBottomColor: colors.buttons_primary,
        borderBottomWidth: StyleSheet.hairlineWidth,
        marginTop: "1%",
        marginBottom: "1%",
    },
    modalButtonsRow: {
        flex: 1,
        flexDirection: "row",
        justifyContent: "flex-end",
        marginRight: Platform.OS === "web" && width > 1300 ? 0 : 40,
        marginBottom: 20,
    },
    actions: {
        width:
            Platform.OS === "web" && width > 1300
                ? width - (width * 35) / 100
                : (width * 80) / 100,
        justifyContent: "center",
        alignItems: "flex-end",
    },
    cardstyle: {
        padding: 10,
        margin: 10,
        width: width > 1300 ? width * 0.70 : width * 0.8,
        borderRadius: 35,
        backgroundColor: colors.background_card,
        elevation: 10,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        position: 'relative',
    },
    inputContainer: {
        margin: 20,
        flex: 1,
        width: isHalfScreen ? '30%' : '100%',
        justifyContent: 'flex-end',
    },
});

export default CustomParticipants;   